import * as React from "react";
import Svg, { Rect, Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={38}
      height={38}
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Rect width={38} height={38} rx={8} fill="#F3F3F3" />
      <Path
        d="M10.868 17.916a4.576 4.576 0 00-4.571 4.571c0 1.275.697 2.814 2.07 4.575a20.959 20.959 0 001.993 2.205l.508.474.508-.474c.04-.038 1.01-.947 1.992-2.205 1.374-1.761 2.071-3.3 2.071-4.575 0-2.52-2.05-4.57-4.57-4.57zm.002 9.758c-.35-.365-.84-.902-1.329-1.528-1.148-1.472-1.756-2.738-1.756-3.659 0-1.7 1.383-3.082 3.083-3.082 1.7 0 3.083 1.382 3.083 3.082 0 1.643-1.908 3.97-3.08 5.187z"
        fill="#000"
        fillOpacity={0.6}
      />
      <Path
        d="M10.868 21.008a1.48 1.48 0 00-1.479 1.48 1.48 1.48 0 001.48 1.478 1.48 1.48 0 001.478-1.479 1.48 1.48 0 00-1.479-1.479zM27.132 7a4.576 4.576 0 00-4.571 4.571c0 1.274.697 2.813 2.07 4.575a20.956 20.956 0 001.993 2.205l.508.474.508-.474a20.95 20.95 0 001.992-2.205c1.374-1.762 2.071-3.3 2.071-4.575 0-2.52-2.05-4.571-4.57-4.571zm0 9.76c-1.173-1.217-3.083-3.545-3.083-5.189 0-1.7 1.383-3.083 3.083-3.083 1.7 0 3.083 1.383 3.083 3.083 0 1.644-1.91 3.972-3.083 5.189z"
        fill="#000"
        fillOpacity={0.6}
      />
      <Path
        d="M27.132 10.092a1.48 1.48 0 00-1.479 1.48 1.48 1.48 0 001.479 1.478 1.48 1.48 0 001.479-1.479 1.48 1.48 0 00-1.479-1.479zM24.403 22.521h-4.162a1.987 1.987 0 01-1.985-1.985c0-1.094.89-1.985 1.985-1.985h3.914v-1.488H20.24a3.477 3.477 0 00-3.473 3.473 3.477 3.477 0 003.474 3.473h4.162c1.095 0 1.985.89 1.985 1.985 0 1.095-.89 1.985-1.985 1.985H13.845v1.488h10.558a3.477 3.477 0 003.473-3.473 3.477 3.477 0 00-3.473-3.473z"
        fill="#000"
        fillOpacity={0.6}
      />
    </Svg>
  );
}

export default SvgComponent;
